// extracted by mini-css-extract-plugin
export default {"policyContainer":"termsAndConditions_policyContainer__ldQXy","policyWrapper":"termsAndConditions_policyWrapper__ZlvNr"};